import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import {
  CRM_EVENT,
  EVENT_BUY_BUTTON_CLICKED,
  EVENT_BUY_STEP,
} from '../actions/crmEvent/crmEventActionConstants';
import {
  postCrmEventSuccess,
  postEventBuyButtonClickedSuccess,
  postEventBuyStepSuccess,
} from '../actions/crmEvent/crmEventActions';
import {
  postCrmEvent,
  postEventBuyButtonClicked,
  postEventBuyFlowSteps,
} from '../../request/crmEventRequest';

function* executeEventBuyButtonClicked({ payload }) {
  try {
    const { data } = yield call(postEventBuyButtonClicked, payload);
    yield put(postEventBuyButtonClickedSuccess(data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    if (payload.onError) {
      yield call(payload.onError, error);
    }
  } finally {
    if (payload?.isLoading) {
      yield call(payload.isLoading, false);
    }
    if (payload?.onConfirm) {
      yield call(payload.onConfirm);
    }
  }
}

function* executeEventBuyFlowSteps({ payload }) {
  try {
    const { data } = yield call(
      postEventBuyFlowSteps,
      payload.accountUid,
      payload.data,
    );
    yield put(postEventBuyStepSuccess(data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(payload.onError, error);
    }
  } finally {
    if (payload?.isLoading) {
      yield call(payload.isLoading, false);
    }
    if (payload?.onConfirm) {
      yield call(payload.onConfirm);
    }
  }
}

function* executeCrmEvent({ payload }) {
  try {
    const { data } = yield call(postCrmEvent, payload.accountUid, payload.data);
    yield put(postCrmEventSuccess(data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(payload.onError, error);
    }
  } finally {
    if (payload?.isLoading) {
      yield call(payload.isLoading, false);
    }
    if (payload?.onConfirm) {
      yield call(payload.onConfirm);
    }
  }
}

export default function* ordersSaga() {
  yield all([
    takeLatest(EVENT_BUY_BUTTON_CLICKED, executeEventBuyButtonClicked),
    takeLatest(EVENT_BUY_STEP, executeEventBuyFlowSteps),
    takeLatest(CRM_EVENT, executeCrmEvent),
  ]);
}
